import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Picture } from "@/components/wpl/image/src/image";

type TestimonialCardProps = {
    readonly image: string;
    readonly quote: string;
    readonly name: string;
    readonly title: string;
};

type TestimonialCardImageProps = {
    readonly image: string;
};

export const TestimonialCardImageQuote = () => {
    return (
        <div css={testimonialQuoteImageStyles}>
            <Picture
                image={{
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8egyb3e0hgar3nj26we824nso1lfh124.webp",
                    alt: "",
                    width: 78,
                    height: 47
                }}
            />
        </div>
    );
};

export const TestimonialCardCustomerImage = ({
    image
}: TestimonialCardImageProps) => {
    return (
        <div css={customerImagePictureStyles}>
            <Picture
                image={{
                    src: image,
                    alt: "",
                    width: 255,
                    height: 238
                }}
            />
        </div>
    );
};

export const TestimonialCard = ({
    image,
    quote,
    name,
    title
}: TestimonialCardProps) => {
    return (
        <div css={cardContainerStyles}>
            <TestimonialCardImageQuote />
            <div css={testimonialQuotesSectionStyles}>
                <TestimonialCardCustomerImage image={image} />
                <div css={quoteContainerStyles}>
                    <p className="quote" css={quoteStyles}>
                        “{quote}”
                    </p>
                    <hr css={hrContainerStyles} />
                    <p className="name" css={nameStyles}>
                        {name}
                    </p>
                    <p className="title" css={titleStyles}>
                        {title}
                    </p>
                </div>
            </div>
        </div>
    );
};

const cardContainerStyles = css({
    position: "relative"
});

const testimonialQuoteImageStyles = css({
    position: "absolute",
    width: "10%",
    insetInlineEnd: "-8%",
    insetBlockStart: "-11%",
    [media.below.md]: {
        display: "none"
    }
});

const testimonialQuotesSectionStyles = css({
    display: "flex",
    color: "#000",
    maxWidth: "776px",
    paddingBlockEnd: "25px",
    background: "#fff",
    borderRadius: "0px var(--large-rounding, 20px)",
    [media.below.sm]: {
        flexDirection: "column",
        maxWidth: "316px"
    }
});

const customerImagePictureStyles = css({
    marginInlineStart: "-1%",
    marginBlockStart: "-1%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: "255px",
        height: "238px"
    }
});

const quoteContainerStyles = css({
    width: "454px",
    marginInlineStart: "5%",
    [media.above.lg]: {
        marginBlockStart: "15px"
    },
    [media.below.sm]: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingInlineEnd: "26px",
        paddingInlineStart: "26px"
    }
});

const quoteStyles = css({
    fontSize: "1.25rem",
    color: "var(--Neutrals-N900, #091E42)",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    [media.below.sm]: {
        maxWidth: "264px",
        margin: "29px, 0 0 15px",
        fontSize: "20px",
        lineHeight: "28px",
        letterSpacing: "0.3px",
        paddingInlineEnd: "26px"
    }
});

const hrContainerStyles = css({
    width: "106px",
    height: "1px",
    color: "#6B778C",
    margin: "16px 0px 0px 0px",
    [media.below.sm]: {
        width: "43px"
    }
});

const nameStyles = css({
    fontSize: "1.2rem",
    fontWeight: 600,
    margin: 0
});

const titleStyles = css({
    margin: 0,
    fontSize: "20px",
    [media.below.sm]: {
        color: " var(--neutral-light-n-800, #172B4D)",
        fontFamily: "var(--atlassian-recommended-system-fonts)",
        fontWeight: "400",
        lineHeight: "24px",
        maxWidth: "183px"
    }
});
